import { ClientSettings } from 'types';

export const initialClientSettings: ClientSettings = {
  profileUrl: ''
};
